import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import SoftUIDashboard from "./soft-ui-dashboard";
import axios from "axios";
//import messages from "./i18n/messages";

axios.defaults.baseURL =
  process.env.NODE_ENV === "production"
    ? "https://" + process.env.VUE_APP_DOMAIN + ".bexter.rs/api/v1/"
    : "http://127.0.0.1:8000/api/v1/";

const i18nFiles = {
  mladostlaravel: require("@/i18n/folklor.js").default,
  courseslaravel: require("@/i18n/courses.js").default,
};

let domainKey = process.env.VUE_APP_DOMAIN;
let messages = i18nFiles[domainKey];

axios.defaults.withCredentials = true;

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  locale: "sr",
  fallbackLocale: "en",
  messages,
});

const appInstance = createApp(App);
appInstance.use(i18n);
appInstance.use(store);
appInstance.use(router);
appInstance.use(SoftUIDashboard);
appInstance.mount("#app");
